import Model from '@/models/Model.js';

export default class QuizAttempt extends Model {
    static entity = 'quiz_attempts';

    static fields() {
        return {
            id: this.attr(null),
            quiz_activity_id: this.attr(null),
            user_id: this.attr(null),
            start_time: this.attr(null),
            end_time: this.attr(null),
            expires_at: this.attr(null),
            comment: this.attr(null),
            survey_activity_id: this.attr(null),
            quiz_version_id: this.attr(null),
            is_preview: this.attr(null),
            is_anonymous: this.attr(null),
            survey_activity: this.attr(null),
            quiz_activity: this.attr(null),
            status: this.attr(null),
            user: this.belongsTo('users', 'user_id'),
            groups: this.attr(null),
            course: this.attr(null),

            ...super.fields(),
        };
    }
}
